import { render, staticRenderFns } from "./StadiumFields.vue?vue&type=template&id=9df603d4&"
import script from "./StadiumFields.vue?vue&type=script&lang=js&"
export * from "./StadiumFields.vue?vue&type=script&lang=js&"
import style0 from "./StadiumFields.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9df603d4')) {
      api.createRecord('9df603d4', component.options)
    } else {
      api.reload('9df603d4', component.options)
    }
    module.hot.accept("./StadiumFields.vue?vue&type=template&id=9df603d4&", function () {
      api.rerender('9df603d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumFields.vue"
export default component.exports